import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9cqnsd3re: FaireProductEntity = {
  token: "p_d9cqnsd3re",
  type: "product",
  name: "Child of God Baby Muslin Swaddle Blanket",
  brandToken: "b_d4x38vshjr",
  brandName: "LollyBanks",
  imageUrl:
    "https://cdn.faire.com/fastly/46a5de78ed22f8b37974bafe077f4d69a628cc60449a8dcb16fb0b4599dc39f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/284b7d20b84ca1977377831e0b8d573a7aff5ca6c0ec6219e4a5d68b04247242.jpeg",
    "https://cdn.faire.com/fastly/91753bdaa25da9d190b52764bf6d0562d3ae19f99a36a67012d2500c0581c03b.jpeg",
    "https://cdn.faire.com/fastly/c2af9ae0e7ec07cd6453d6b0dc268af173c00d85265dbfbc56e2d3a4fa0fbc9a.jpeg",
    "https://cdn.faire.com/fastly/45cbee99f4d90ec4ababe5f0547abcca72caafbe1caab2a8a538bb6e0a7a81d5.jpeg",
    "https://cdn.faire.com/fastly/eba2f9602be80d3ce52a6a59e6b7b896f7e364212761f586cbdb141cf6064218.jpeg",
    "https://cdn.faire.com/fastly/ea6c750709cc4197e140b55320e3ff6f5dab666c76ffaac515c92d865f53d732.jpeg",
  ],
  priceDollars: 7.49,
  description:
    "* SOFT AND COZY SWADDLING BLANKET - Wrap your little loves in LollyBanks extra soft 100% cotton muslin swaddles to make your baby feel safe and secure. Each 47x47 blanket provides enough space to snuggly and securely wrap your newborn as well as provide comfort through the toddler years. \nCHILD OF GOD SWADDLE - This Christian print is perfect for keeping in the nursery or using as a stroller cover for your baby. Moms and dads will love receiving these as a baby shower gift or welcome present.\n * BREATHABLE AND LIGHTWEIGHT - This swaddle is made from high-quality 100% cotton muslin fabric giving you peace of mind knowing that you are wrapping your baby in a breathable yet durable blanket that will stand the test of time and will save as a keepsake for years to come!",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:44.454Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
